<template>
  <div class="thirdPartyServices">
    <div class="left">
      <listMenu
        v-for="item in menuList"
        :itemData="item"
        :key="item.name"
        pathPrefix="thirdPartyServices"
        :before="before"
      />
    </div>
    <div class="right">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
    <weikaifang ref="weikaifangRef" />
  </div>
</template>
<script>
import listMenu from "@/components/listMenu/listMenu.vue";
import weikaifang from "@/components/weikaifang/index.vue";
export default {
  components: {
    listMenu,
    weikaifang,
  },
  data() {
    return {
      menuList: [
        {
          title: "申请出证",
          name: "issueCertificateList",
          icon: "el-icon-ali-hetongmoban",
        },
        {
          title: "执行代理",
          name: "actingList",
          icon: "el-icon-ali-wodegoumai",
          authority: [],
        },
      ],
    };
  },
  methods: {
    async before({ name }) {
      if (name === "actingList") {
        this.$refs.weikaifangRef.onshow();
        return Promise.reject();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.thirdPartyServices {
  @include contentStyle2;
}
</style>
